/**
 * Max height (px) of the Ant Design table body on report pages using `.diInfo`.
 * Matches `scroll.y` and `.diInfo .ant-table-body` max-height.
 * Tuned from 520px (~18 compact rows) so ~15 data rows fit before vertical scroll.
 */
// Dynamic height to fill viewport and eliminate white space below the table
export const REPORT_TABLE_BODY_MAX_PX = "calc(100vh - 250px)";
